import { getFirebaseFunctionDefinition } from "../../utils/getFirebaseFunctionDefinition";
import { UpdateOrganizationRequestStruct } from "../types/UpdateOrganizationRequest";

export const updateOrganizationDefinition = getFirebaseFunctionDefinition({
  path: "/organizations/update",
  reqType: UpdateOrganizationRequestStruct,
});
